<template>
  <div>
    <div class="heading-style">
      <span v-if="!moderation">{{$t('menu.myResources')}}</span>
      <span v-else>{{$t('general.narrowResources')}}</span>
    </div>
    <div
      v-if="!moderation"
      class="uk-flex uk-flex-middle add-pointer resource-state-container"
      :class="[selectedItem == 'shared' ? 'selected-menu-item-style': '', 'menu-style']"
      @click="onSharedResourcesClicked">
      <img :class="{'visible': newApprovedResources, 'hidden': !newApprovedResources}"
           class="new-items-indicator-style" :src="newApprovedItems"/>
      <span class="resource-state-style">{{$t('general.sharedResources')}}</span>
      <span class="resource-state-count-style">{{approvedResources}}</span>
    </div>
    <div
      class="uk-flex uk-flex-middle add-pointer resource-state-container"
      :class="[selectedItem == 'pending' ? 'selected-menu-item-style': '', 'menu-style']"
      @click="onPendingApprovalClicked">
      <img :class="{'visible': newPendingResources, 'hidden': !newPendingResources}"
           class="new-items-indicator-style" :src="newPendingItems"/>
      <span class="resource-state-style">{{$t('general.pendingApproval')}}</span>
      <span class="resource-state-count-style">{{pendingResources}}</span>
    </div>
    <div
      class="uk-flex uk-flex-middle add-pointer resource-state-container"
      :class="[selectedItem == 'declined' ? 'selected-menu-item-style': '', 'menu-style']"
      @click="onDeclinedResourcesClicked">
      <img :class="{'visible': newDeclinedResources, 'hidden': !newDeclinedResources}"
           class="new-items-indicator-style" :src="newDeclinedItems"/>
      <span class="resource-state-style">{{$t('general.declined')}}</span>
      <span class="resource-state-count-style">{{declinedResources}}</span>
    </div>
  </div>
</template>

<script>
  import * as moderationStatus from '../../../../enums/moderation-status'
  import iconUtil from '../../../../utils/icon-util'
  import * as misc from '../../../../enums/misc'
  export default {
    name: 'navigation',
    props: ['approvedResources', 'pendingResources', 'declinedResources', 'selectedItem', 'newPendingResources', 'newDeclinedResources', 'newApprovedResources', 'moderation'],
    data() {
      return {
        newPendingItems: iconUtil.resolve(misc.PENDING_MENU_INDICATOR),
        newApprovedItems: iconUtil.resolve(misc.APPROVED_MENU_INDICATOR),
        newDeclinedItems: iconUtil.resolve(misc.DECLINED_MENU_INDICATOR)
      }
    },
    methods: {
      onSharedResourcesClicked() {
        this.$emit('onClick', moderationStatus.SHARED)
      },
      onPendingApprovalClicked() {
        this.$emit('onClick', moderationStatus.PENDING)
      },
      onDeclinedResourcesClicked() {
        this.$emit('onClick', moderationStatus.DECLINED)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../styles/colours';

  .heading-style {
    font-size: 18px;
    font-weight: bold;
    color: $content-text;
    margin-bottom: 27px;
  }

  .menu-style {
    width: 100%;
    height: 30px;
    border: solid 1px #e3e5e8;
    background-color: rgba(255, 255, 255, 0.4);
    margin-bottom: 2px;
    &:hover {
      background-color: white;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
      .resource-state-style {
        color: $content-link-blue;
      }
    }
  }

  .resource-state-container {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .resource-state-count-style {
    margin-left: auto;
    margin-right: 6px
  }

  .resource-state-style {
    margin-left: 7px;
    color: $content-text;
    font-size: 16px;
  }

  .selected-menu-item-style {
    background-color: white;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    .resource-state-style {
      color: $content-link-blue;
    }
  }
  .new-items-indicator-style {
    margin-left: 7px;
  }
  .hidden {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
</style>
